export default __webpack_public_path__ + "static/media/ImportVendor.6bf0d9cc.csv";